// @flow
import React, {useMemo} from 'react';
import {makeStyles} from '@material-ui/core';

import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';

import type {CheckoutInput, Order} from '../../../../../entities';
import type {UseFormRegister} from 'react-hook-form';

type Props = {
  register: UseFormRegister<typeof HTMLInputElement>,
  errors: {[key: string]: {type: string, message: string}} | {},
  item: CheckoutInput,
  order?: Order,
};

const useStyles = makeStyles(theme => ({
  label: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
}));

export default function NumberInput(props: Props) {
  const {register, item, errors, order} = props;
  const classes = useStyles();
  const inputRegisteredName = item.id;

  const orderAdditionalInfo = useMemo(() => {
    if (order && order.additionalInformation) {
      return order.additionalInformation.find(
        el => el.storeOrderAdditionalInformation.id === item.id
      );
    }
  }, [item, order]);

  return (
    <label className={classes.label}>
      <span>{item.name}</span>
      <CustomTextField
        name={inputRegisteredName}
        defaultValue={
          orderAdditionalInfo?.additionalInformation?.value[0] ?? ''
        }
        error={!!errors[inputRegisteredName]}
        helperText={
          errors[inputRegisteredName] ? errors[inputRegisteredName].message : ''
        }
        inputRef={register({
          required: item.required ? 'Campo obligatorio' : undefined,
          pattern: {
            value: /^[0-9]*$/i,
            message: 'Formato de número inválido',
          },
        })}
      />
    </label>
  );
}
